package ru.villawonka.app.domain.model

sealed interface NetworkFailure {

    /**
     * Ошибка соединения с сетью
     */
    data object NoConnection : NetworkFailure

    /**
     * Юзер не авторизован
     */
    data object Unauthorized : NetworkFailure

    /**
     * Ничего не найдено по запросу
     */
    data object NotFound : NetworkFailure

    /**
     * Неизвестная сетевая ошибка
     */
    data class HttpError(
        val code: Int,
        val message: String
    ) : NetworkFailure
}